/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCallbackAmbulanzRequest
 */
export interface CreateCallbackAmbulanzRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCallbackAmbulanzRequest
     */
    originTimeZoneId: string;
}

/**
 * Check if a given object implements the CreateCallbackAmbulanzRequest interface.
 */
export function instanceOfCreateCallbackAmbulanzRequest(value: object): value is CreateCallbackAmbulanzRequest {
    if (!('originTimeZoneId' in value) || value['originTimeZoneId'] === undefined) return false;
    return true;
}

export function CreateCallbackAmbulanzRequestFromJSON(json: any): CreateCallbackAmbulanzRequest {
    return CreateCallbackAmbulanzRequestFromJSONTyped(json, false);
}

export function CreateCallbackAmbulanzRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCallbackAmbulanzRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'originTimeZoneId': json['originTimeZoneId'],
    };
}

export function CreateCallbackAmbulanzRequestToJSON(json: any): CreateCallbackAmbulanzRequest {
    return CreateCallbackAmbulanzRequestToJSONTyped(json, false);
}

export function CreateCallbackAmbulanzRequestToJSONTyped(value?: CreateCallbackAmbulanzRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'originTimeZoneId': value['originTimeZoneId'],
    };
}

